"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "guidonia-montecelio": {
    "b8421d35": [{
      "hkey": "c35ce04e",
      "slug": "colleverde",
      "name": "Colleverde",
      "primary": true,
      "skipSearch": false
    }],
    "colle-verde": [{
      "hkey": "c35ce04e",
      "slug": "colleverde",
      "name": "Colleverde",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d8263d60": [{
      "hkey": "ffdf783d",
      "slug": "marco-simone",
      "name": "Marco Simone",
      "primary": true,
      "skipSearch": false
    }],
    "marco-simone-vecchio": [{
      "hkey": "ffdf783d",
      "slug": "marco-simone",
      "name": "Marco Simone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "guidonia-montecelio"
    }],
    "fe060276": [{
      "hkey": "c35ce04e",
      "slug": "colleverde",
      "name": "Colleverde",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-fiorito": [{
      "hkey": "c35ce04e",
      "slug": "colleverde",
      "name": "Colleverde",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "guidonia-montecelio"
    }]
  }
};
exports["default"] = _default;